import React from 'react';
import Input from '../../../components/BaseInput';

export default function CreditCardInput({ value, onChange, name = 'expDate', error = false }) {
  return (
    <div className="form-group card-input">
      <Input
        type="text"
        name={name}
        error={error}
        value={value}
        onChange={onChange}
        placeholder="MM/YY"
        autoComplete="cc-exp"
      />
    </div>
  );
}
